// Module
var code = "<p>Активные разрешения определяют аккаунты, которые имеют разрешение тратить средства этого аккаунта.</p> <p>Они могут быть использованы для упрощенной настройки схемы с мульти-подписью, смотрите раздел <a href=\"accounts/permissions\">разрешения</a> чтобы узнать подробности.</p> ";
// Exports
export default code;